import {RescaleSvc} from 'services/RescaleSvc';
import {HttpSvcFactory} from 'services/HttpSvc';
import {AuthenticationSvc} from '../services/AuthenticationSvc';
import {PlayerSvc} from '../services/PlayerSvc';
import {AnimatronPreviews} from '../services/AnimatronPreviewsSvc';
import {Utils} from 'underscore-extensions';

export interface ProfileProjectStateParams extends ng.ui.IStateParamsService {
    customize?: string;
    bgColor?: boolean;
    username?: string;
}

export class ProfileProjectCtrl {
    customize: any;
    pickPreview: any;
    setBgColorFromMovie: any;
    animatron: any;
    standartProjects: any;
    myProjects: any;
    choosen: any;
    pickProjectEl: HTMLElement;
    playerId: string;
    currentTab: string;
    currentPage: number;
    canPick: boolean;
    loading: boolean;
    projectPickerShown: boolean;
    projectId?: string;
    tabs: Array<string>;

    constructor(private $scope: ng.IScope,
                private $rootScope: ng.IRootScopeService,
                private $stateParams: ProfileProjectStateParams,
                private $q: ng.IQService,
                private AnimatronProjects: any,
                private AnimatronPreviews: AnimatronPreviews,
                private HttpSvc: HttpSvcFactory,
                private Player: PlayerSvc,
                private AuthenticationSvc: AuthenticationSvc) {
        this.customize = $stateParams.customize;
        this.setBgColorFromMovie = $stateParams.bgColor;
        this.pickPreview = AnimatronPreviews.pickPreview;
        this.playerId = 'profile-project';
        this.pickProjectEl = document.querySelector('.pick-project');

        if (this.customize) this.pickUserProject();
        this.watchForLink($scope);

        $scope.$watch(() => options.user.username === decodeURIComponent($stateParams.username),
            val => this.canPick = val
        );

        $rootScope.$on('project:remove', (e, projectId) => {
                if (this.projectId === projectId) this.removeProject();
            }
        );
    }

    onTabChange(tab: string) {
        if (tab === 'standard-animations') {
            this.animatron = this.getStandartProjects();
        } else if (tab === 'my-animations') {
            this.animatron = angular.copy(this.myProjects());
            this.animatron.changeLimit(8);
        }
        if (tab) {
            this.currentPage = 1;
            this.loadProjects();
        }
    }

    getStandartProjects() {
        if (!this.standartProjects) {
            this.standartProjects = new this.AnimatronProjects({
                limit: 8,
                tag: 'Standard-Profile',
                tag_type: 'SUPER',
                sortBy: 'tag_creation_time'
            });
        }
        return this.standartProjects;
    }

    loadProjects() {
        if (this.animatron.results.length === 0) {
            this.animatron.loadPage(this.currentPage);
        }
    }

    pickUserProject() {
        this.choosen = null;
        this.projectPickerShown = true;

        this.tabs = ['standard-animations'];
        if (this.myProjects().count > 0) {
            this.tabs.push('my-animations');
        }
        this.currentTab = this.tabs[this.tabs.indexOf(this.customize)] || this.tabs[0];
    }

    pickChosenProject(choosenProject: anm.Project) {
        this.AuthenticationSvc.extendUser({meta: {profileProject: choosenProject.id}});
        this.HttpSvc('profile/profile-project').securePut(choosenProject.id);
        this.projectPickerShown = false;
        this.projectId = choosenProject.id;
    }

    resetPlayer() {
        return this.Player.resetPlayerById(this.playerId);
    }

    removeProject() {
        this.HttpSvc('profile/profile-project').secureDelete();
        this.projectId = undefined;
        this.AuthenticationSvc.extendUser({meta: {profileProject: undefined}});
        return this.resetPlayer();
    }

    watchForLink($scope: ng.IScope) {
        $scope.$watch(() => this.projectId, (id: string) => {
            if (angular.isString(id) && id.length === 24) {
                this.loading = true;
                this.HttpSvc('project', this.projectId).get().then(r => r.data).then((response: anm.Project) => {
                    if (Utils.isApiError(response)) return this.$q.reject(this.loading = false);
                    return this.$q.all([this.Player.getProjectUrl(response), this.resetPlayer()]);
                }).then(([link]) => {
                    return this.Player.createPlayer(
                        link.replace('http:', 'https:'),
                        this.playerId, {
                            ribbonsColor: 'transparent',
                            autoPlay: true,
                            audioEnabled: false,
                            controlsEnabled: false
                        });
                }).then(player => {
                    this.loading = false;
                    if (this.setBgColorFromMovie) {
                        document.querySelector('.user-section').style['background-color'] = player.anim.bgfill._style;
                    }
                    this.$rootScope.$on('notOnScreen:' + this.playerId, () => player && player.pause());
                    this.$rootScope.$on('onScreen:' + this.playerId, () => player && player.play(Math.max(0, player.getTime())));
                    this.resizePlayerFunc(player)();
                    const func = _.throttle(this.resizePlayerFunc(player), 500);
                    Utils.scopedEvent('resize', $scope, func);
                }).catch(() => {
                    this.loading = false;
                    this.projectId = null;
                });
            }
        });
        $scope.$on('$destroy', () => this.resetPlayer());
    }

    resizePlayerFunc(player?: Player) {
        return () => {
            if (!player) return;
            const userSectionRect = this.getBoundingRectOfUserSection();
            const dim = RescaleSvc.resizeWithAspectRatio(
                player.width * 9999,
                player.height * 9999,
                window.innerWidth - 32,
                userSectionRect.height);
            player.setSize(dim.width, dim.height);
        };
    }

    getBoundingRectOfUserSection() {
        this.pickProjectEl.style.position = 'absolute';
        const selector          = document.querySelector('.user-section');
        const userSectionRect = selector && selector.getBoundingClientRect();
        this.pickProjectEl.style.position = 'relative';
        return userSectionRect;
    }
}

angular.module('animatronApp.profileProject').directive('profileProject', () => {
    return {
        restrict: 'E',
        scope: {
            projectId: '=',
            myProjects: '&'
        },
        controller: ProfileProjectCtrl,
        controllerAs: 'ProfileProjectCtrl',
        bindToController: true,
        templateUrl: require('profile-project.html')
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/profileProjectDirective.ts